import { useEffect, useState } from "react";
import editIcon from "../../assests/icons/edit.jpg";
import viewIcon from "../../assests/icons/read.png";
import messageIcon from "../../assests/icons/message.png";
import noNessageIcon from "../../assests/icons/no-message.png";
import bulkMessageIcon from "../../assests/icons/bulk-message.png";
import reportIcon from "../../assests/icons/report.png";
import { searchMemberObject, get } from "../../network/lib/member.js";
import { Link } from "react-router-dom";
import { showHideLoader } from "../utils/helper.js";
import {
  getAreas,
  getBloodGroups,
  getGenders,
  getStatus,
} from "../../network/lib/masterData.js";
import { isAdmin, isApprover, isPublisher } from "../utils/auth.js";

function SearchMember({ user }) {
  const [status, setStatus] = useState();
  const [bloodGroups, setBloodGroups] = useState();
  const [genders, setGenders] = useState();
  const [areas, setAreas] = useState();
  const [name, setName] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [bloodGroup, setBloodGroup] = useState(0);
  const [gender, setGender] = useState(0);
  const [dateOfBirthFrom, setDateOfBirthFrom] = useState("");
  const [dateOfBirthTo, setDateOfBirthTo] = useState("");
  const [dateOfJoiningFrom, setDateOfJoiningFrom] = useState("");
  const [dateOfJoiningTo, setDateOfJoiningTo] = useState("");
  const [area, setArea] = useState(0);
  const [messageSubscriped, setMessageSubscriped] = useState(false);
  const [liveData, setLiveData] = useState();
  const [freshRecord, setFreshRecord] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 10;
  const [agedFilter, SetAgedFilter] = useState(false);

  const admin = isAdmin(user.roleId);
  const approver = isApprover(user.roleId);
  const publisher = isPublisher(user.roleId);

  useEffect(() => {
    !status &&
      getStatus().then((resp) => {
        resp.status == 200 && setStatus(resp.data);
      });
    !bloodGroups &&
      getBloodGroups().then((resp) => {
        resp.status == 200 && setBloodGroups(resp.data);
      });
    !genders &&
      getGenders().then((resp) => {
        resp.status == 200 && setGenders(resp.data);
      });
    !areas &&
      getAreas().then((resp) => {
        resp.status == 200 && setAreas(resp.data);
      });
  }, []);

  const setToDefault = () => {
    setName("");
    setSelectedStatus(0);
    setGender(0);
    setBloodGroup(0);
    setDateOfBirthFrom("");
    setDateOfBirthTo("");
    setDateOfJoiningFrom("");
    setDateOfJoiningTo("");
    setArea(0);
    setMessageSubscriped(false);
    setFreshRecord(false);
    setLiveData(undefined);
    setCurrentPage(1);
    setTotalPages(0);
    SetAgedFilter(false);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const fetchRecord = (pageNumber) => {
    showHideLoader(true);
    let message = resetMessage();

    searchMemberObject.name = name;
    searchMemberObject.status = selectedStatus;
    searchMemberObject.gender = gender;
    searchMemberObject.bloodGroup = bloodGroup;
    searchMemberObject.dateOfBirthFrom = dateOfBirthFrom;
    searchMemberObject.dateOfBirthTo = dateOfBirthTo;
    searchMemberObject.dateOfJoiningFrom = dateOfJoiningFrom;
    searchMemberObject.dateOfJoiningTo = dateOfJoiningTo;
    searchMemberObject.area = area;
    searchMemberObject.isMessageSubscriped = messageSubscriped;
    searchMemberObject.pageSize = itemsPerPage;
    searchMemberObject.pageNumber = pageNumber;
    searchMemberObject.isAgeFilterApplied = agedFilter;

    get(searchMemberObject).then((res) => {
      if (res.status == 200 && res.data) {
        message.classList.replace("alert", "success");
        let result = res.data;
        const length = result.total;
        message.innerHTML = `${length} records found`;
        if (length > 0) {
          setLiveData(result.records);
          setCurrentPage(pageNumber);
          setTotalPages(Math.ceil(length / itemsPerPage));
          setFreshRecord(true);
        }
      } else {
        message.innerHTML = "Some error occurred. Please try again";
      }
      showHideLoader();
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    setLiveData(undefined);

    if (
      name == "" &&
      (selectedStatus == 0 || selectedStatus == "0") &&
      (bloodGroup == 0 || bloodGroup == "0") &&
      (gender == 0 || gender == "0") &&
      (area == 0 || area == "0") &&
      dateOfBirthFrom == "" &&
      dateOfBirthTo == "" &&
      dateOfJoiningFrom == "" &&
      dateOfJoiningTo == "" &&
      !messageSubscriped &&
      !agedFilter
    ) {
      message.innerHTML = "Please select atleast one serach parameter";
    } else if (
      (dateOfBirthFrom != "" && dateOfBirthTo == "") ||
      (dateOfJoiningFrom != "" && dateOfJoiningTo == "")
    ) {
      message.innerHTML = "Please provide Date To";
    } else if (
      (dateOfBirthFrom == "" && dateOfBirthTo != "") ||
      (dateOfJoiningFrom == "" && dateOfJoiningTo != "")
    ) {
      message.innerHTML = "Please provide Date From";
    } else {
      fetchRecord(1);
    }
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <th align="center" colSpan="4">
              Member Search
            </th>
          </tr>
          <tr>
            <td colSpan={4} align="right">
              <Link to="/admin/savemember">
                <span>New Member</span>
              </Link>
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Name</span>
            </td>
            <td>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setFreshRecord(false);
                }}
                style={{ width: "206px" }}
              />
            </td>
            <td align="right">
              <span>Status</span>
            </td>
            <td>
              {status && (
                <select
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setFreshRecord(false);
                  }}
                  value={selectedStatus}
                  style={{ width: "224px" }}
                >
                  <option value="0">Select</option>
                  {status.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Gender</span>
            </td>
            <td>
              {genders && (
                <select
                  onChange={(e) => {
                    setGender(e.target.value);
                    setFreshRecord(false);
                  }}
                  value={gender}
                  style={{ width: "224px" }}
                >
                  <option value="0">Select</option>
                  {genders.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>Blood Group</span>
            </td>
            <td>
              {bloodGroups && (
                <select
                  onChange={(e) => {
                    setBloodGroup(e.target.value);
                    setFreshRecord(false);
                  }}
                  value={bloodGroup}
                  style={{ width: "224px" }}
                >
                  <option value="0">Select</option>
                  {bloodGroups.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Date of Birth From</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfBirthFrom}
                onChange={(e) => {
                  setDateOfBirthFrom(e.target.value);
                  setFreshRecord(false);
                }}
                style={{ width: "206px" }}
              />
            </td>
            <td align="right">
              <span>Date of Birth To</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfBirthTo}
                onChange={(e) => {
                  setDateOfBirthTo(e.target.value);
                  setFreshRecord(false);
                }}
                style={{ width: "206px" }}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Date of Joining From</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfJoiningFrom}
                onChange={(e) => {
                  setDateOfJoiningFrom(e.target.value);
                  setFreshRecord(false);
                }}
                style={{ width: "206px" }}
              />
            </td>
            <td align="right">
              <span>Date of Joining To</span>
            </td>
            <td>
              <input
                type="date"
                value={dateOfJoiningTo}
                onChange={(e) => {
                  setDateOfJoiningTo(e.target.value);
                  setFreshRecord(false);
                }}
                style={{ width: "206px" }}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Area</span>
            </td>
            <td>
              {areas && (
                <select
                  onChange={(e) => {
                    setArea(e.target.value);
                    setFreshRecord(false);
                  }}
                  value={area}
                  style={{ width: "224px" }}
                >
                  <option value="0">Select</option>
                  {areas.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
            <td align="right">
              <span>Message Subscriped</span>
            </td>
            <td>
              <input
                type="checkbox"
                checked={messageSubscriped}
                onChange={() => {
                  setMessageSubscriped(!messageSubscriped);
                  setFreshRecord(false);
                }}
              />
            </td>
          </tr>
          <tr>
            <td align="right">
               <span>Membership registration duration </span>
            </td>
            <td>
              <input type="checkbox" checked={agedFilter}
                      onChange={  () => {
                                          SetAgedFilter(!agedFilter);
                                          setFreshRecord(false);
                                        }
                                }
              /> (require 10 yrs)
            </td>
          </tr>
          <tr>
            <td colSpan={2}></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "62px" }}
            >
              <input
                type="submit"
                className="btn"
                id="btnCancel"
                onClick={handleCancel}
                value="Cancel"
              />
              &nbsp;&nbsp;
              <input
                className="btn"
                type="submit"
                id="btnSubmit"
                onClick={handleSubmit}
                value="Search"
              />
            </td>
          </tr>
          <tr>
            <td colSpan="9" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
      {liveData && (
        <table className="alternate-row">
          <thead>
            <tr>
              <td align="right" colSpan={publisher ? 9 : 8}>
                {publisher && messageSubscriped && freshRecord && (
                  <Link to="/admin/sendmessage">
                    <img
                      className="handle"
                      src={bulkMessageIcon}
                      onClick={() => {
                        localStorage.removeItem("sendMessage");
                        localStorage.setItem(
                          "sendMessage",
                          JSON.stringify({ single: false })
                        );
                      }}
                      id="btnSend"
                      alt="Send Message"
                      border="0px"
                      style={{
                        width: "30px",
                        height: "30px",
                        marginRight: "30px",
                      }}
                    />
                  </Link>
                )}
                <Link to="/admin/report" target="_blank">
                  <img
                    className="handle"
                    onClick={() => {
                      localStorage.removeItem("searchResult");
                      localStorage.setItem(
                        "searchResult",
                        JSON.stringify({ records: liveData })
                      );
                    }}
                    src={reportIcon}
                    alt="Read"
                    border="0px"
                    style={{ width: "30px", height: "30px" }}
                  />
                </Link>
              </td>
            </tr>
            <tr>
              <th align="center" colSpan={publisher ? 9 : 8}>
                Members
              </th>
            </tr>
            <tr>
              <td colSpan={publisher ? 9 : 8}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              <td>
                <u>Id</u>
              </td>
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Mobile</u>
              </td>
              <td>
                <u>Date of Birth</u>
              </td>
              <td>
                <u>Area</u>
              </td>
              <td>
                <u>Date of Joining</u>
              </td>
              <td>
                <u>Edit</u>
              </td>
              <td>
                <u>View</u>
              </td>
              {publisher && (
                <td>
                  <u>Send</u>
                </td>
              )}
            </tr>
            {liveData.length > 0 ? (
              liveData.map((x, i) => (
                <tr key={i} style={{ textAlign: "center" }}>
                  <td>{x.id}</td>
                  <td>{x.name}</td>
                  <td>{x.mobile}</td>
                  <td>{x.dateOfBirth}</td>
                  <td>{x.area}</td>
                  <td>{x.dateOfJoining}</td>
                  <td>
                    <Link to="/admin/savemember">
                      <img
                        className="handle"
                        onClick={() => {
                          localStorage.removeItem("userDetails");
                          localStorage.setItem(
                            "userDetails",
                            JSON.stringify({ ...x, isEdit: true })
                          );
                        }}
                        src={editIcon}
                        alt="Edit"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </Link>
                  </td>
                  <td>
                    <Link to="/admin/savemember">
                      <img
                        className="handle"
                        onClick={() => {
                          localStorage.removeItem("userDetails");
                          localStorage.setItem(
                            "userDetails",
                            JSON.stringify({ ...x, isRead: true })
                          );
                        }}
                        src={viewIcon}
                        alt="Read"
                        border="0px"
                        style={{ width: "20px", height: "20px" }}
                      />
                    </Link>
                  </td>
                  {publisher && (
                    <td>
                      {x.statusId != 3 &&
                      x.isMessageSubscriped &&
                      x.mobile.length == 10 ? (
                        <Link to="/admin/sendmessage">
                          <img
                            className="handle"
                            onClick={() => {
                              localStorage.removeItem("sendMessage");
                              localStorage.setItem(
                                "sendMessage",
                                JSON.stringify({
                                  user: { ...x },
                                  single: true,
                                })
                              );
                            }}
                            data-params={x.id}
                            src={messageIcon}
                            alt="send"
                            border="0px"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </Link>
                      ) : (
                        <img
                          className="no-handle"
                          data-params={x.id}
                          src={noNessageIcon}
                          alt="send"
                          border="0px"
                          style={{ width: "20px", height: "20px" }}
                        />
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={publisher ? 9 : 8} style={{ textAlign: "center" }}>
                  No Data available
                </td>
              </tr>
            )}
          </tbody>
          {totalPages > 1 && (
            <tfoot>
              <tr>
                <td align="center" colSpan={publisher ? 9 : 8}>
                  <input
                    className="btn"
                    type="button"
                    onClick={() => fetchRecord(currentPage - 1)}
                    disabled={currentPage === 1}
                    value="Previous"
                  />
                  <span>
                    &nbsp;&nbsp;Page {currentPage} of {totalPages}
                  </span>
                  <input
                    className="btn"
                    type="button"
                    onClick={() => fetchRecord(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    value="Next"
                  />
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      )}
    </>
  );

  return contents;
}

export default SearchMember;
